/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { fonts, themes } from '../../../common/themes/themes';
import coverImage from '../../../assets/images/coverImage.png';
import './PersonalDetails.css';
import ChangeProfilePicController from '../../../common/components/ChangeProfilePic/ChangeProfilePicController';
import PersonalInfoController from '../../../domain/myProfile/personalDetails/personalInfo/PersonalInfoController';
import JobInfoController from '../../../domain/myProfile/personalDetails/jobInfo/JobInfoController';
import EmergencyContactController from '../../../domain/myProfile/personalDetails/emergencyContact/EmergencyContactController';
import BankInfoController from '../../../domain/myProfile/personalDetails/bankInfo/BankInfoController';
import SkillsDetailsController from '../../../domain/myProfile/personalDetails/skills/SkillsDetailsController';
import AboutMeController from '../../../domain/myProfile/personalDetails/aboutMe/AboutMeController';
import Loader from '../../../common/Lottifiers/Loader/Loader';
import { useAppSelector } from '../../../infra/hooks';
import AnimatedPage from '../../../common/AnimatedPage/AnimatedPage';

interface empDetailProps {
  employeeDetail: {
    name: string;
    designation: string;
    profilePic: any;
  };
  isLoading?: any;
  trans?: any;
  i18n?: any;
}

const PersonalDetailsPresenter: React.FC<empDetailProps> = ({
  employeeDetail,
  isLoading,
  trans,
  i18n,
}) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <Grid
      container
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        marginTop: isHRView ? '' : '4em',
        width: '100vw',
        paddingRight: isHRView && i18n.language == 'ar' ? '1em' : '8em',
      }}
    >
      {isLoading ? (
        <Loader height={100} width={200} />
      ) : (
        <Grid
          item
          xs={11}
          sm={11}
          md={11}
          lg={11}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: '#F5F5FA',
            width: '100%',
            padding: '1.75em',
            marginLeft:
              isHRView && i18n.language == 'en'
                ? '11em'
                : !isHRView && i18n.language == 'en'
                  ? '14em'
                  : '',
            marginRight: i18n.language == 'ar' ? '15em' : '',
          }}
        >
          <Grid
            container
            style={{
              paddingLeft: isHRView ? '2em' : '',
            }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{
                width: '100%',
                marginBottom: '1.5em',
              }}
            >
              <Grid
                container
                style={{
                  width: 'auto',
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  borderRadius: '10px',
                  opacity: '1',
                  display: 'flex',
                  flexDirection: 'row',
                  paddingTop: '1em',
                  paddingBottom: '1em',
                  paddingLeft: '1em',
                  paddingRight: '1em',
                }}
              >
                <Grid item xs={9}>
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.header,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Personal Details')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box
                sx={{
                  width: 'auto',
                  height: '146px',
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                  opacity: '1',
                  backgroundImage: `url(${coverImage})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <Grid
                  container
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Grid item>
                    <Box style={{ marginBottom: '70px' }} />
                    <Box>
                      <ChangeProfilePicController
                        reporter={{
                          emp_designation: employeeDetail?.designation,
                          emp_name: employeeDetail?.name,
                          emp_pic: employeeDetail?.profilePic,
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className="half-cover-below"
              ></Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <AnimatedPage>
                <Grid
                  container
                  spacing={3}
                  style={{
                    marginTop: '0.8em',
                    width: 'auto',
                  }}
                >
                  <Grid item xs={4} sm={4} md={4} lg={4}>
                    <AboutMeController />
                    <Box style={{ marginTop: '1.75em' }} />
                    <PersonalInfoController />
                  </Grid>
                  <Grid item xs={4} sm={4} md={4} lg={4}>
                    <JobInfoController />
                    <Box style={{ marginTop: '1.75em' }} />
                    <SkillsDetailsController />
                  </Grid>
                  <Grid item xs={4} sm={4} md={4} lg={4}>
                    {' '}
                    <EmergencyContactController />
                    <Box style={{ marginTop: '1.75em' }} />
                    <BankInfoController />
                  </Grid>
                </Grid>
              </AnimatedPage>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default PersonalDetailsPresenter;
